import { render, staticRenderFns } from "./DAHazardousForm.vue?vue&type=template&id=0ef259db"
import script from "./DAHazardousForm.vue?vue&type=script&lang=js"
export * from "./DAHazardousForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports